var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImagotipoEthics2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 30,
    viewBox: "0 0 35 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.942 8.125c1.804 0 3.272 1.436 3.272 3.218 0 1.773-1.468 3.211-3.272 3.211-1.805 0-3.264-1.438-3.264-3.21 0-1.783 1.46-3.22 3.264-3.22zm0 17.063L5.522 11.51l9.42 7.935 11.394-11.27c-2.58-3.472-6.781-5.732-11.529-5.732C6.961 2.443.6 8.61.6 16.22S6.961 30 14.807 30c7.846 0 14.206-6.168 14.206-13.779a13.39 13.39 0 0 0-1.815-6.737L14.942 25.188z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.6 0-8.264 8.175c.312.419.6.855.862 1.31L34.6 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagotipoEthics2);
export default __webpack_public_path__ + "static/media/imagotipo-ethics_2.c9094830d2e44bbf9165ee3b0e27f7bb.svg";
export { ForwardRef as ReactComponent };